import { MarketingConfig } from "@/types";

export const marketingConfig = (m?: any): MarketingConfig => ({
  mainNav: [
    {
      title: m?.track_portfolios() ?? "",
      href: "#portfolio",
    },
    {
      title: m?.smart_allocation() ?? "",
      href: "#allocation",
    },
    {
      title: m?.advance_trading() ?? "",
      href: "#trading",
    },
    {
      title: m?.Pricing() ?? "",
      href: "/pricing",
    },
  ],
});
